/* loaded by smart-asset */
export default require("./assets/dock-door-closed.i.svg")